'use strict';
function dataService($http, $q) {

    var searchBaseUrl = "/api/search";

    this.searchQueue = [];
    this.searchOffers = function (filter) {
        var canceller = $q.defer();

        var cancel = function (reason) {
            canceller.resolve(reason);
        };

        var http = {
            method: 'POST',
            timeout: canceller.promise,
            url: searchBaseUrl,
            data: filter
        }

        if (window.current_location != null) {
            http.headers = {
                'current-location': window.current_location
            };
        }
        var promise = $http(http);

        return {
            promise: promise,
            cancel: cancel
        };
    };
    this.loadFilters = function (country) {
        return $http.get(searchBaseUrl + "/loadFilters/" + (country || ""));
    }

    this.getAreas = function (country) {
        return $http.get(searchBaseUrl + "/loadAreas/" + country);
    }

    this.getGoogleCoordination = function (term) {
        return $http.get("//maps.google.com/maps/api/geocode/json?components=country:au&address=" + term);
    };

    this.suggest = function (term, categories) {
        var canceller = $q.defer();

        var cancel = function (reason) {
            canceller.resolve(reason);
        };

        var promise = $http({
            method: 'GET',
            timeout: canceller.promise,
            url: searchBaseUrl + "/suggestion?term=" + encodeURIComponent(term) + "&categories=" + categories
        });

        return {
            promise: promise,
            cancel: cancel
        };
    };

    this.addToFavourites = function (merchantID) {
        return $http.get("/api/favourites/" + merchantID + "/add");
    };

    this.removeFromFavourites = function (merchantID) {
        return $http.get("/api/favourites/" + merchantID + "/remove");
    };

    this.myFavourites = function () {
        var canceller = $q.defer();

        var cancel = function (reason) {
            canceller.resolve(reason);
        };

        var promise = $http({
            method: 'GET',
            timeout: canceller.promise,
            url: "/api/favourites/myfavourites"
        });

        return {
            promise: promise,
            cancel: cancel
        };
    }

    this.getOffer = function (id, locationID) {
        var canceller = $q.defer();

        var cancel = function (reason) {
            canceller.resolve(reason);
        };

        var promise = $http({
            method: 'GET',
            timeout: canceller.promise,
            url: "/api/offers/" + id + "?locationId=" + locationID
        });

        return {
            promise: promise,
            cancel: cancel
        };
    }

    this.getOfferReviews = function(id) {
        return $http.get("/api/offers/" + id + "/reviews?orderDesc=true");
    }

    this.getOfferRedemptionHistory = function (id) {
        return $http.get("/api/fvmember/redemptions/" + id);
    }

    this.listRedemptions = function (page) {
        return $http.get("/api/redemption/list?page=" + page);
    };
}

function handlePendingRequests(vm, callStore, req) {
    vm[callStore] = vm[callStore] || [];
    vm[callStore].forEach(function (r) {
        r.cancel("new request");
        vm[callStore].splice(vm[callStore].indexOf(r), 1);
    });
    vm[callStore].push(req);
}